import {
  Box,
  Button,
  Chip,
  TextField,
  Typography,
} from '@mui/material';
import LabeledBox from '../../special/LabeledBox';
import { useEffect, useState } from 'react';
import ExoDialog from '../../exo/ExoDialog';
import { useTranslation } from 'react-i18next';
import ExoTabs from '../../exo/ExoTabs';
import ContactsIcon from '@mui/icons-material/Contacts';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import SelectCompanies from '../../select/SelectCompanies';
import SelectContacts from '../../select/SelectContacts';
import SelectEmployees from '../../select/SelectEmployees';
import SelectLeadPersons from '../../select/SelectLeadPersons';
import SelectLeadCompanies from '../../select/SelectLeadCompanies';
import { SelectFromNameValueArray } from '../../select/SelectFromNameValueArray';
import Feedback from '../../special/Feedback';

const TypeMailSelect = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [selection, setSelection] = useState(dataCollection[field.key] || []);

  function handleSelectionChange(value) {
    updateValidationOnChange([field.key], value);
    setSelection(value);
  }

  return (
    <>
      <LabeledBox
        className="col-span-2"
        onClick={() => setOpen(true)}
        label={field.label}
      >
        {selection.length === 0 && t('No CC Selected')}
        {selection.map((item, index) => (
          <MailItem item={item} key={index} />
        ))}
      </LabeledBox>
      <ExoDialog open={open} limitWidth>
        <SelectMail
          label={field.label}
          onCancel={() => setOpen(false)}
          onSave={handleSelectionChange}
          startData={selection}
        />
      </ExoDialog>
    </>
  );
};

const MailItem = ({ item, onDelete = () => {} }) => {
  return (
    <Typography onClick={() => onDelete(item)}>
      <b>{item.name}</b> {`<${item.email}>`}
    </Typography>
  );
};

const SelectMail = ({ label, onCancel, onSave, startData }) => {
  const { t } = useTranslation();
  const [deliveryCCData, setDeliveryCCData] = useState([]);
  const [nameValueData, setNameValueData] = useState({});
  const [elementSave, setElementSave] = useState(null);

  const [selection, setSelection] = useState({
    company: [],
    contact: [],
    employee: [],
    leadPerson: [],
    leadCompany: [],
    custom: [],
  });
  const [preSelected, setPreSelected] = useState({
    company: [],
    contact: [],
    employee: [],
    leadPerson: [],
    leadCompany: [],
    custom: [],
  });
  useEffect(() => {
    setSelection({
      company: startData.filter((obj) => obj.type === 'company'),
      contact: startData.filter((obj) => obj.type === 'contact'),
      employee: startData.filter((obj) => obj.type === 'employee'),
      leadPerson: startData.filter((obj) => obj.type === 'leadPerson'),
      leadCompany: startData.filter((obj) => obj.type === 'leadCompany'),
      custom: startData.filter((obj) => obj.type === 'custom'),
    });
  }, [startData]);

  const tabs = [
    {
      label: t('Companies'),
      content: (
        <SelectCompanies
          onSelect={handleCompanysSelect}
          dataCollection={selection.company}
        />
      ),
      icon: <ApartmentIcon />,
    },
    {
      label: t('Contacts'),
      content: (
        <SelectContacts
          onSelect={handleContactsSelect}
          dataCollection={selection.contact}
        />
      ),
      icon: <ContactsIcon />,
    },
    {
      label: t('Employees'),
      content: (
        <SelectEmployees
          onSelect={handleEmployeesSelect}
          preSelected={preSelected.employee}
        />
      ),
      icon: <PeopleOutlinedIcon />,
    },
    {
      label: t('Lead Persons'),
      content: (
        <SelectLeadPersons
          onSelect={handleLeadPersonsSelect}
          dataCollection={selection.leadPerson}
        />
      ),
      icon: <PersonSearchIcon />,
    },
    {
      label: t('Lead Companies'),
      content: (
        <SelectLeadCompanies
          onSelect={handleLeadCompaniesSelect}
          dataCollection={selection.leadCompany}
        />
      ),
      icon: <StorefrontIcon />,
    },
    {
      label: t('Custom Email Address'),
      content: (
        <CustomEmailTab
          selection={selection.custom}
          onAdd={(entry) =>
            setSelection({
              ...selection,
              custom: [...selection.custom, entry],
            })
          }
          onRemove={(entry) =>
            setSelection({
              ...selection,
              custom: selection.custom.filter((e) => e.email !== entry.email),
            })
          }
        />
      ),
      icon: <AlternateEmailIcon />,
    },
  ];

  function handleCompanysSelect(data, element) {
    if (element && !element.emails.length) {
      handleFeedback(t('No E-Mail address found'), 'error');
      return setSelection({ ...selection, company: [...selection.company] });
    }
    if (element) {
      setElementSave({ element, type: 'company' });
      setNameValueData({
        array: element.emails,
        nameKey: 'emailType',
        valueKey: 'emailAddress',
      });
    } else {
      setSelection({
        ...selection,
        company: removeItemFromArray(selection.company, data),
      });
    }
  }

  function handleContactsSelect(data, element) {
    if (element && !element.emails.length) {
      handleFeedback(t('No E-Mail address found'), 'error');
      return setSelection({ ...selection, contact: [...selection.contact] });
    }
    if (element) {
      setElementSave({ element, type: 'contact' });
      setNameValueData({
        array: element.emails,
        nameKey: 'emailType',
        valueKey: 'emailAddress',
      });
    } else {
      setSelection({
        ...selection,
        contact: removeItemFromArray(selection.contact, data),
      });
    }
  }
  function handleEmployeesSelect(data) {
    setSelection({ ...selection, employee: data });
  }

  function handleLeadPersonsSelect(data, element) {
    if (element && !element.emails.length) {
      handleFeedback(t('No E-Mail address found'), 'error');
      return setSelection({ ...selection, leadPerson: [...selection.leadPerson] });
    }
    if (element) {
      setElementSave({ element, type: 'leadPerson' });
      setNameValueData({
        array: element.emails,
        nameKey: 'emailType',
        valueKey: 'emailAddress',
      });
    } else {
      setSelection({
        ...selection,
        leadPerson: removeItemFromArray(selection.leadPerson, data),
      });
    }
  }

  function handleLeadCompaniesSelect(data, element) {
    if (element && !element.emails.length) {
      handleFeedback(t('No E-Mail address found'), 'error');
      return setSelection({ ...selection, leadCompany: [...selection.leadCompany] });
    }
    if (element) {
      setElementSave({ element, type: 'leadCompany' });
      setNameValueData({
        array: element.emails,
        nameKey: 'emailType',
        valueKey: 'emailAddress',
      });
    } else {
      setSelection({
        ...selection,
        leadCompany: removeItemFromArray(selection.leadCompany, data),
      });
    }
  }

  function handleEmailSelect(email) {
    var newArray = selection[elementSave.type];
    newArray.push({ ...elementSave.element, email });

    setSelection({
      ...selection,
      [elementSave.type]: newArray,
    });
    setNameValueData({});
  }

  function removeItemFromArray(arrA, arrB) {
    return arrA.filter((itemA) => arrB.some((itemB) => itemA.id === itemB.id));
  }

  useEffect(() => {
    generateCCDeliveryData();
  }, [selection]);

  function generateCCDeliveryData() {
    var newDeliveryCCData = [];
    selection.company.forEach((element) => {
      newDeliveryCCData.push({
        email: element.email,
        name: element.name,
        type: 'company',
        id: element.id,
      });
    });
    selection.contact.forEach((element) => {
      newDeliveryCCData.push({
        email: element.email,
        name: `${element.salutation} ${element.firstName} ${element.lastName}`,
        type: 'contact',
        id: element.id,
      });
    });
    selection.employee.forEach((element) => {
      newDeliveryCCData.push({
        email: element.email,
        name: `${element.salutation} ${element.firstName} ${element.lastName}`,
        type: 'employee',
        id: element.id,
      });
    });
    selection.leadPerson.forEach((element) => {
      newDeliveryCCData.push({
        email: element.email,
        name: `${element.salutation} ${element.firstName} ${element.lastName}`,
        type: 'leadPerson',
        id: element.id,
      });
    });
    selection.leadCompany.forEach((element) => {
      newDeliveryCCData.push({
        email: element.email,
        name: element.name,
        type: 'leadCompany',
        id: element.id,
      });
    });
    selection.custom.forEach((element) => {
      newDeliveryCCData.push({
        email: element.email,
        name: element.name || element.email,
        type: 'custom',
      });
    });
    setDeliveryCCData(newDeliveryCCData);
  }

  function handleSave() {
    onSave(deliveryCCData);
    onCancel();
  }

  function handleDelete(item) {
    const newSelection = [...selection[item.type]];
    const index =
      item.type === 'custom'
        ? newSelection.findIndex((obj) => obj.email === item.email)
        : newSelection.findIndex((obj) => obj.id === item.id);
    if (index >= 0) {
      newSelection.splice(index, 1);
    }
    setSelection({ ...selection, [item.type]: newSelection });
    setPreSelected({ ...selection, [item.type]: newSelection });
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }
  return (
    <Box className="flex flex-col h-full justify-between gap-2 overflow-hidden">
      <Box className="flex flex-col h-full gap-2 overflow-hidden pt-2">
        <LabeledBox label={label}>
          <Box
            className="overflow-y-auto flex flex-wrap gap-1"
            sx={{ maxHeight: '100px' }}
          >
            {deliveryCCData.length === 0 && (
              <Typography className="opacity-50" fontSize={14}>
                {t('No Mails Selected')}
              </Typography>
            )}
            {deliveryCCData.map((item, index) => (
              <Chip
                key={`${item.type}-${item.id || item.email}-${index}`}
                label={
                  item.name && item.name !== item.email
                    ? `${item.name} <${item.email}>`
                    : item.email
                }
                onDelete={() => handleDelete(item)}
                size="small"
              />
            ))}
          </Box>
        </LabeledBox>
        <ExoTabs tabs={tabs} />
      </Box>
      <Box className="flex justify-between p-2">
        <Button variant="outlined" color="error" onClick={onCancel}>
          {t('Cancel')}
        </Button>
        <Button variant="contained" color="success" onClick={handleSave}>
          {t('Save')}
        </Button>
      </Box>
      <ExoDialog open={Boolean(nameValueData.array)} limitWidth>
        <SelectFromNameValueArray
          label="Select email"
          array={nameValueData.array}
          nameKey={nameValueData.nameKey}
          valueKey={nameValueData.valueKey}
          onSelect={handleEmailSelect}
        />
      </ExoDialog>
      <Feedback state={alertState} setState={setAlertState} />
    </Box>
  );
};

const CustomEmailTab = ({ selection, onAdd, onRemove }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  function handleAdd() {
    if (!isValidEmail) return;
    if (selection.some((e) => e.email === email)) return;
    onAdd({ name: name || email, email });
    setName('');
    setEmail('');
  }

  return (
    <Box className="flex flex-col gap-3 p-2 w-full">
      <TextField
        label={t('Name') + ` (${t('optional')})`}
        value={name}
        onChange={(e) => setName(e.target.value)}
        fullWidth
      />
      <Box className="flex gap-2 w-full">
        <TextField
          label={t('E-Mail')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAdd();
            }
          }}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleAdd}
          disabled={!isValidEmail}
          sx={{ minWidth: 'unset', px: 2 }}
        >
          +
        </Button>
      </Box>
      {selection.length > 0 && (
        <Box className="flex flex-wrap gap-1 mt-1">
          {selection.map((entry) => (
            <Chip
              key={entry.email}
              label={
                entry.name && entry.name !== entry.email
                  ? `${entry.name} <${entry.email}>`
                  : entry.email
              }
              onDelete={() => onRemove(entry)}
              size="small"
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default TypeMailSelect;
